// Mother-level default values for the postnatal consultation form. Per-baby
// values are seeded separately via buildInitialBabyObsState (KIN-1075).
export const getPostnatalDefaultValues = (consultation) => {
  if (!consultation) {
    return {
      issues: "",
      postNatalMood: "",
      supports: "",
      mirena: "",
      contraception: "",
      para: "",
      gravida: "",
    };
  }

  return {
    issues: consultation.mother?.issuesDuringOrSincePregnancy ?? "",
    postNatalMood: consultation.mother?.postNatalMood ?? "",
    supports: consultation.mother?.supports ?? "",
    mirena: consultation.mother?.mirena ?? "",
    contraception: consultation.mother?.contraception ?? "",
    para: consultation.mother?.para ?? "",
    gravida: consultation.mother?.gravida ?? "",
  };
};
